<div class="login-card-major" *ngIf ="websiteName == 'Major'" >
  <div>
    
    <form class="login-form" (ngSubmit)="onSignInSubmit()"    #onSubmit="ngForm" novalidate>
      <div class="has-error okta-error" *ngIf="login.errorMessage">
        <span
          class="glyphicon glyphicon-exclamation-sign error-exclamation"
        ></span>
        <p class="show-message">
          <span title="{{ login.errorMessage }}">{{ login.errorMessage }}</span>
        </p>
      </div>
      <div class="has-error okta-error" *ngIf="login.isSessionTimeOut">
        <span
          class="glyphicon glyphicon-exclamation-sign error-exclamation"
        ></span>
        <p class="show-message bold">
          For security purposes you will need to sign in again in order to
          continue your activity.
        </p>
      </div>
      <button mat-icon-button class="close-button" [mat-dialog-close]="true">
        <mat-icon class="close-icon" >close</mat-icon>
      </button>
      <div style="padding: 0 5% 0 5%;">
      <div  class="row">
        <div class="form-group">
        <label for="username" style="color: #4b4343; margin-bottom: 0px !important;">Username<span class="required">*</span></label>          
        <input type="text" id="username"
        class="form-control"
        name="username"
        required
        #username="ngModel"
        placeholder="Please enter your username" 
        [(ngModel)]="login.username">
        <mat-error  *ngIf="username.errors?.required  && onSubmit.submitted"
          >Please enter your username</mat-error
        >
        </div>
      </div>
      <div  class="row">
        <div class="form-group">
        <label for="password" style="color: #4b4343; margin-bottom: 20px !important;">Password<span class="required">*</span></label>    
        <input
        class="form-control"
          id="password"
          type="password"
          name="password"
          required
          #password="ngModel"
          placeholder="Please enter your password"
          [(ngModel)]="login.password"
        />
        <mat-error  *ngIf="password.errors?.required  && onSubmit.submitted"
          >Please enter your password</mat-error
        >
        </div>
        
      </div>
      </div>
      <div class="login-action-buttons-major">
        <button class="signin-btn"   id="btn-signin" mat-raised-button color="accent" type="submit">
          Sign in
          <img src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
        </button>
      </div>
      </form>
      <a style="color: #4b4343;"id="forgot-password" (click)="onForgotPasswordClick()">Forgot your password?</a>
      <br/>
      <p class="show-message-margin-top">For your security, account passwords will expire every 90 days. You will be alerted at login when your password is nearing expiration.</p>
    </div>
</div> 
<mat-card class="login-card"  *ngIf ="websiteName == 'Parmed'">
  <mat-card-content>
    <div class="text-center header-logo login-logo">
    </div>
    <form class="login-form" (ngSubmit)="onSignInSubmit()" novalidate>
      <div class="has-error okta-error" *ngIf="login.errorMessage">
        <span
          class="glyphicon glyphicon-exclamation-sign error-exclamation"
        ></span>
        <p class="show-message">
          <span title="{{ login.errorMessage }}">{{ login.errorMessage }}</span>
        </p>
      </div>
      <div class="has-error okta-error" *ngIf="login.isSessionTimeOut">
        <span
          class="glyphicon glyphicon-exclamation-sign error-exclamation"
        ></span>
        <p class="show-message bold">
          For security purposes you will need to sign in again in order to
          continue your activity.
        </p>
      </div>
      <mat-form-field class="login-control">
        <input
          id="username"
          matInput
          name="username"
          required
          #username="ngModel"
          placeholder="Username"
          [(ngModel)]="login.username"
          parAutoFocus
        />
        <mat-error *ngIf="username.errors?.required"
          >Please enter your username</mat-error
        >
      </mat-form-field>
      <mat-form-field class="login-control" >
        <input 
          id="password"
          matInput
          type="password"
          name="password"
          required
          #password="ngModel"
          placeholder="Password"
          [(ngModel)]="login.password"
        />
        <mat-error *ngIf="password.errors?.required"
          >Please enter your password</mat-error
        >
      </mat-form-field>
      <div class="login-action-buttons">
        <button id="btn-signin" mat-raised-button color="accent" type="submit">
          Sign in
        </button>
        <button
          id="btn-close"
          mat-raised-button
          color="accent"
          [mat-dialog-close]="false"
        >
          Close
        </button>
      </div>
      </form>
      <a id="forgot-password" (click)="onForgotPasswordClick()">Forgot Password?</a>
      <br/>
      <p class="show-message-margin-top">For your security, account passwords will expire every 90 days. You will be alerted at login when your password is nearing expiration.</p>
  </mat-card-content>
</mat-card>  


